import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import DOMPurify from "dompurify";
import { FaQuoteLeft } from "react-icons/fa6";
import { useAboutContext } from "../../context/About_context";
import Loader from "../../Common/loader/Loader";
import { renderTitleWithGradient } from "../../utils/helper";
import "./DirectorsMessage.css";

/* ---------- Scroll Reveal Wrapper (Pure CSS) ---------- */
const Reveal = ({ children, className = "", delay = 0 }) => {
  return (
    <div
      className={`dm-reveal ${className}`.trim()}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const DirectorsMessage = () => {
  const { director_loading, director_data, GetDirector } = useAboutContext();

  useEffect(() => {
    GetDirector();
  }, []); // eslint-disable-line

  if (director_loading) {
    return <Loader fullScreen={true} text="Loading Director's Message..." />;
  }

  return (
    <div className="dm-royal-page">
      <Helmet>
        <title>Director's Message | Bharat Buildcon</title>
      </Helmet>
      {/* Background Soft Mesh Orbs */}
      <div className="dm-royal-bg-wrapper" aria-hidden="true">
        <div className="dm-royal-orb dm-royal-orb-1" />
        <div className="dm-royal-orb dm-royal-orb-2" />
      </div>

      <div className="dm-royal-container">
        {/* ---------------- BREADCRUMB & HEADER ---------------- */}
        <header className="dm-royal-header">
          <div className="clean-breadcrumb-wrapper">
            <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
              <Link to="/" className="bc-home-link">
                HOME
              </Link>
              <span className="bc-slash">/</span>
              <span className="bc-active-page">DIRECTOR&apos;S MESSAGE</span>
            </nav>
          </div>

          <Reveal>
            {director_data?.sub_heading && (
              <div className="dm-royal-badge">
                <span>{director_data?.sub_heading}</span>
              </div>
            )}
            {director_data?.heading && (
              <h1 className="dm-royal-title">
                {renderTitleWithGradient(director_data?.heading)}
              </h1>
            )}
          </Reveal>
        </header>

        {/* ---------------- DYNAMIC CARD ---------------- */}
        {director_data?.director_description && (
          <Reveal delay={100}>
            <div className="dm-royal-card">
              <div className="dm-royal-tricolor-bar" />
              <FaQuoteLeft className="dm-royal-watermark" />

              <div
                className="dm-royal-description-content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(director_data?.director_description),
                }}
              />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  );
};

export default DirectorsMessage;
